import { render, staticRenderFns } from "./FoodRecord.vue?vue&type=template&id=7a44c007"
import script from "./FoodRecord.vue?vue&type=script&lang=js"
export * from "./FoodRecord.vue?vue&type=script&lang=js"
import style0 from "./FoodRecord.vue?vue&type=style&index=0&id=7a44c007&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a44c007')) {
      api.createRecord('7a44c007', component.options)
    } else {
      api.reload('7a44c007', component.options)
    }
    module.hot.accept("./FoodRecord.vue?vue&type=template&id=7a44c007", function () {
      api.rerender('7a44c007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/FoodRecord.vue"
export default component.exports